// extracted by mini-css-extract-plugin
export var himsAboutsSection = "sectionTitle-module--himsAboutsSection--3c9c6";
export var mix_heading = "sectionTitle-module--mix_heading--5d168";
export var mix_heading_Root = "sectionTitle-module--mix_heading_Root--8c10c";
export var mix_heading_wrap = "sectionTitle-module--mix_heading_wrap--084fa";
export var remove = "sectionTitle-module--remove--3060e";
export var viewAllLink = "sectionTitle-module--viewAllLink--b638e";